import { OrderDetailsTHandlingLogAssignmentOrderCancelEvent } from "../../../common/types/order-details-handling-log-entry-event";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";

const getRouteLabel = (
  planEntryUuid: OrderDetailsTHandlingLogAssignmentOrderCancelEvent["planEntryUuid"],
) => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .assignmentOrderCancel.routeLabel;

  return translations.replace(
    "#{planEntryUuid}",
    planEntryUuid.toString() ?? "-----",
  );
};

const orderDetailsHistoryEntryAssignmentOrderCancelContentHelper = {
  getRouteLabel,
};

export default orderDetailsHistoryEntryAssignmentOrderCancelContentHelper;
